<!-- Slideout setting section -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">
        <!-- The header of this section -->
        Template
    </div>
    <div class="custom-setting-section-context">
        <!-- Context beneath the header, usually showing an overview of what is selected without expanding the section -->
        {{ exampleSettingValue }}
    </div>
    <div class="custom-setting-section-body">
        <!-- The controls to change settings, will be shown when the section is expanded -->
        <div class="mb-2 font-size-12">Example Setting</div>
        <input class="form-control mb-3" type="text" [(ngModel)]="exampleSettingValue" />
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection position="top" [moduleManager]="moduleManager">
        <!-- Any settings you want above the generic settings will go here -->
        <label>Example Setting</label>
        <input type="text" [(ngModel)]="exampleSettingValue" />
    </div>

    <!-- Generic settings will be in between -->

    <div cvModuleLegacyCustomSettingSection position="bottom" [moduleManager]="moduleManager">
        <!-- Any settings you want below the generic settings will go here
            Note that any markup not inside a 'gridItemSettingsPanelCustomSettingsBottomItem' 
            will be placed above the generic settings 
        -->
    </div>
</ng-container>

<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <!-- Not specifying after or inside will place the setting above everything -->
    <div class="form-group" cvModuleCxoneCustomSettingSection [moduleManager]="moduleManager">
        <label>Example Top Setting</label>
        <input class="form-control" type="text" [(ngModel)]="exampleSettingValue" />
    </div>

    <!-- Specifying after will place the setting after a specific section -->
    <div class="form-group" cvModuleCxoneCustomSettingSection after="dates" [moduleManager]="moduleManager">
        <label>Example After Date Setting</label>
        <input class="form-control" type="text" [(ngModel)]="exampleSettingValue" />
    </div>

    <!-- Specifying inside will place the setting inside a specific section -->
    <!-- Note this won't show up on TS Template as this module has no emp section -->
    <div cvModuleCxoneCustomSettingSection inside="emp" [moduleManager]="moduleManager">
        <label>Example Inside Emp Setting</label>
        <input class="form-control" type="text" [(ngModel)]="exampleSettingValue" />
    </div>
</ng-container>
